export default {
  title: "مدیریت وبسایت",
  aboutUs: "مدیریت About us",
  policy: "مدیریت Policy",
  faq: "مدیریت FAQ",
  carousel: "مدیریت Carousel",
  slider: "مدیریت Slider",
  usedProducts: "محصولات دست دوم",
};
